import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { useEffect } from 'react';

import Empty from '@components/common/Empty';
import { LinkItem } from '@components/common/ListItem';
import NativeInFeedAd from '@components/common/NativeInFeedAd';
import { PaginationIterator } from '@components/common/Pagination';
import CurationBanner from '@components/search/CurationBannert';
import Story from '@components/stories/Story';

import { fetchSectionStories } from '@api/common';
import { QUERY_KEYS } from '@constants';
import { jsonStringify } from '@utils/misc';
import { usePaginationQuery } from '@utils/query';
import { useWebView } from '@utils/webview';

export const SectionStoryList = ({
  sectionId,
  screen,
}: {
  sectionId: number;
  screen?: string;
}) => {
  const { t } = useTranslation();

  const router = useRouter();
  const queryKey = QUERY_KEYS.SECTION_STORY.LIST(sectionId);
  const query = usePaginationQuery(queryKey, ({ pageParam }) =>
    fetchSectionStories(sectionId, pageParam)
  );

  const { web } = useWebView();

  useEffect(() => {
    if (screen) {
      web.data('screen', {
        screenName: `메인/홈/${screen}`,
        parameters: jsonStringify(router?.query),
      });
    }
  }, [screen]);

  return (
    <>
      <CurationBanner sectionId={sectionId} />
      <PaginationIterator name="section-story-list" query={query} border inFeedAd={<NativeInFeedAd unitKey="home_cp_mobile" />}>
        {(item) => (
          <LinkItem
            hideArrow
            newTab
            to={`/stories/${item.id}`}
            left={<Story {...item} />}
          />
        )}
      </PaginationIterator>
      <Empty query={query}>
        <p>{t('작품이 없습니다.')}</p>
      </Empty>
    </>
  );
};
